import { render, staticRenderFns } from "./EditItem.vue?vue&type=template&id=494aec0d&scoped=true"
import script from "./EditItem.vue?vue&type=script&lang=js"
export * from "./EditItem.vue?vue&type=script&lang=js"
import style0 from "./EditItem.vue?vue&type=style&index=0&id=494aec0d&prod&scoped=true&lang=css"
import style1 from "./EditItem.vue?vue&type=style&index=1&id=494aec0d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494aec0d",
  null
  
)

export default component.exports